import {Component, Prop, Vue} from "vue-property-decorator";
import {Tab, Tabs} from "~/components/tabs";

export enum ClientTab {
  Profile,
  Subscription,
  Infos
}

@Component
export class ClientNavigationTabs extends Vue {

  @Prop({type: Number, required: true}) value: ClientTab;

  render() {
    return (
      <Tabs>
        <Tab isActive={this.value === ClientTab.Profile}
             onClick={() => this.$emit("input", ClientTab.Profile)}>
          Profil Client
        </Tab>
        <Tab isActive={this.value === ClientTab.Subscription}
             onClick={() => this.$emit("input", ClientTab.Subscription)}>
          Abonnement
        </Tab>
      </Tabs>
    );
  }

}


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-66baced7/navigation-tabs.tsx" });